import home from "../images/home.png";
import feedback from "../images/feedback.png";
import { openAccessTokenModal } from "../components/AccessTokenModal";

export const teacherMenuItems = [
  { icon: null, label: "Download", key: "Download", onClick: () => (window.location.href = "/teacher/download") },
  { icon: home, label: "Dashboard", key: "home" },
  { icon: feedback, label: "Feedback", key: "feedback" },
  // { icon: null, label: "AnaVu Web", key: "anavu-web-beta" },
  {
    icon: null,
    label: "AnaVu Web",
    key: "anavu-web-beta",
    onClick: () => (window.location.href = "/lessons"), // ✅ works without useNavigate
    // onClick: openAccessTokenModal,
  },
  // { icon: tutorials, label: "Tutorials", key: "tutorials", disabled: true },
  // { icon: history, label: "History", key: "history", disabled: true },
];

export const teacherDownloadMenuItems = [
  { icon: home, label: "Dashboard", key: "home" },
];

export const learnerMenuItems = [
  { icon: null, label: "Download", key: "Download", onClick: () => (window.location.href = "/learner/download") },
  { icon: home, label: "Dashboard", key: "home" },
  { icon: feedback, label: "Feedback", key: "feedback" },
  {
    icon: null,
    label: "AnaVu Web",
    key: "anavu-web-beta",
    onClick: () => (window.location.href = "/lessons"), // ✅ works without useNavigate
    // onClick: openAccessTokenModal, // Trigger modal on click
  },
  // { icon: tutorials, label: "Tutorials", key: "tutorials", disabled: true },
  // { icon: history, label: "History", key: "history", disabled: true },
];
